export default __webpack_public_path__ + "static/community-end-hero-55ef4536935bcfeda4d22b07759cfe6f.jpg";